var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"74cf9375d86abb94a7d675e2420c77a9feb4a878"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    ignoreErrors: [
      /load failed/i,
      'Failed to fetch',
      'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission',
      'Illegal invocation',
      'The operation was aborted',
      'The play() request was interrupted by a call to pause()',
      /Invariant: attempted to hard navigate to the same URL/
    ],
    beforeSend(event) {
      const stackOverflow = event.exception?.values?.find((exception) =>
        exception.value?.includes('Maximum call stack size exceeded')
      );
      const fromOurBundle = stackOverflow?.stacktrace?.frames?.some((frame) =>
        frame.filename?.includes('/_next/')
      );
      return stackOverflow && !fromOurBundle ? null : event;
    },
  });
}
